import React from 'react'
import './Header.css';
import logoAmsa from '../asset/new_logoAmsa.png';
import logoAprica from '../asset/new_logoAprica.png';
import refresh from '../asset/newRefresh.png';
import {Button, Col, Container, Row} from "react-bootstrap";

const Header = ({onReset, jobId}) => (

    <Container fluid>
        <style type="text/css">
            {`
                    .btn-restart {
                         color: #FFFFFF;

                    }
                `}
        </style>
        <Row className="header-web-chat">
            <Col xs={3} sm={2} md={2} lg={1}>
                {jobId === "520" || jobId === "632" || jobId === "2826" || jobId === "2955" ? (
                    <img className="header-logo-amsa" alt='logo' src={logoAmsa} />
                ) : (
                    <img className="header-logo-aprica" alt='logo' src={logoAprica} />
                )}
            </Col>
            <Col xs={9} md={10}>
                <div className="header-webchat content">
                    <h2 className="header-content">Guido</h2>
                    <span className="header-description">Il tuo assistente per le candidature</span>
                </div>
            </Col>
            <Col xs={2} sm={2} md={2} lg={1}>
                <Button className="restart" variant="restart" size="sm" onClick={e => onReset(e)}>
                    <img className="icon"
                         src={refresh}
                         alt="Riavvia">
                    </img>
                </Button>
            </Col>
        </Row>
    </Container>
);

function tpLogo(value) {
    if (value === "520" || value === "632"|| value === "2826" || value === "2955") {
        return logoAmsa
    } else if (value === "539" || value === "633" || value === "2827"|| value === "2956") {
        return logoAprica;
    } else return logoAmsa
}

export default Header
